import {useEffect, useState} from "react";
import {ReactComponent as ArrowUp} from "../../../assets/svg/arrow-up.svg";
import "./BackToTopButton.css";


const VISIBILITY_THRESHOLD = 0.5;


export default function BackToTopButton() {
  const [isVisible, setIsVisible] = useState(false);


  useEffect(() => {
    let ticking = false;

    const updateVisibility = () => {
      const scrollableHeight = document.documentElement.scrollHeight - window.innerHeight;
      const scrolledRatio = scrollableHeight > 0 ? window.scrollY / scrollableHeight : 0;

      setIsVisible(scrolledRatio >= VISIBILITY_THRESHOLD);
    };

    const handleScroll = () => {
      if (ticking) return;

      ticking = true;

      window.requestAnimationFrame(() => {
        updateVisibility();
        ticking = false;
      });
    };

    updateVisibility();
    window.addEventListener("scroll", handleScroll, {passive: true});
    window.addEventListener("resize", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleScroll);
    };
  }, []);


  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };


  return (
    <button
      className={`back-to-top ${isVisible ? "visible" : ""}`}
      onClick={scrollToTop}
      aria-label="Back to start page"
    >
      <ArrowUp className="back-to-top-icon"/>
    </button>
  );
}